import { render } from "./index.vue?vue&type=template&id=3c2d7e15&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c2d7e15&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-rating-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2d7e15"]])

export default __exports__